import React, { useEffect, useState } from 'react';
const EmotionBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Add a slight delay before showing the banner
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);
  return <section className="py-12 md:py-16 bg-gradient-to-br from-[#E87B5C] to-[#D16A4A]" data-id="element-46">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        <div className={`flex flex-col md:flex-row items-center gap-8 md:gap-12 transition-all duration-700 ${isVisible ? 'opacity-100 transform-none' : 'opacity-0 translate-y-8'}`} data-id="element-48">
          <div className="md:w-3/5" data-id="element-49">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 pt-2" data-id="element-50">
              Never Text <span className="italic" data-id="element-51">Alone</span> Again
            </h2>
            <div className="max-w-[90%] space-y-4" data-id="element-52">
              <p className="text-lg text-white/95 leading-relaxed" data-id="element-53">
                Whether you're messaging a partner, a friend, or a colleague,
                every word matters. Emigo helps you communicate with clarity,
                confidence, and empathy, so your messages build connection, not
                confusion.
              </p>
              <p className="text-lg md:text-xl text-white leading-relaxed" data-id="element-54">
                <strong data-id="element-55">
                  <em data-id="element-56">
                    Your everyday communication companion, making every
                    conversation smoother and smarter.
                  </em>
                </strong>
              </p>
            </div>
          </div>
          <div className="md:w-2/5 mt-6 md:mt-0" data-id="element-57">
            <div className="relative w-4/5 mx-auto overflow-hidden transform transition-all duration-300 hover:scale-[1.03]" data-id="element-58">
              <div className="rounded-3xl border-2 border-white/30 overflow-hidden shadow-xl" data-id="element-59">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1BFtASY61spJpxYTANeeSk/Yellow_Soccer.png" alt="Emotion Characters Playing Soccer" className="w-full rounded-2xl transform transition-transform hover:scale-[1.02] duration-500" data-id="element-60" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-3xl" data-id="element-61"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default EmotionBanner;